import axios from "axios"
import router from '../../router';

const state = {
    CheckListList: [],
    CheckListNoMoreData: false,
    Loading:false,
    UpdateCheckListList:true,
    GetCheckListModalList:[],
    CheckListModalNoMoreData: false,
};

import { func } from '../../main';



const getters = {
    GetCheckListList(state:any) {
        return state.CheckListList;
    },
    GetCheckListModalList(state:any) {
        return state.CheckListModalList;
    },
    GetCheckListNoMoreData(state:any) {
        return state.CheckListNoMoreData;
    },
    GetCheckListModalNoMoreData(state:any) {
        return state.CheckListModalNoMoreData;
    },
    GetUpdateCheckListList(state:any) {
        return state.UpdateCheckListList;
    },

};

const mutations = {

    SetCheckListList(state:any, list:any) {
        state.CheckListList = list;
    },
    AddCheckListList(state:any, list:any) {
        state.CheckListList.push.spread(state.CheckListList, list);
    },
    SetCheckListNoMoreData(state:any, val:any) {
        state.CheckListNoMoreData = val;
    },
    SetUpdateCheckListList(state:any, val:any) {
        state.UpdateCheckListList = val;
    },
    SetCheckListModalList(state:any, list:any) {
        state.CheckListModalList = list;
    },
    AddCheckListModalList(state:any, list:any) {
        state.CheckListModalList.push.spread(state.CheckListModalList, list);
    },
    SetCheckListModalNoMoreData(state:any, val:any) {
        state.CheckListModalNoMoreData = val;
    },
};

const actions = {
    GetCheckListListFromServer(context:any, Filter:any) {
        if (Filter == null) {
            Filter = { searchKey: "" };
        }
        if (state.Loading == true) {
            return;
        }
        context.commit("SetLoading", true);
        axios.get("CheckList/GetCheckListList", {
            params: {
                page: Filter.pageId,
                filterId: Filter.filterId,
                searchKey: Filter.searchKey,
                date: Filter.date,
                type: Filter.type,
            }
        })
            .then((data:  any) => {
                context.commit("SetLoading", false);
                context.commit('SetUpdateCheckListList', false);

                if (data.data.length < 1) {
                    context.commit("SetCheckListNoMoreData", true);
                    if (Filter.pageId == 1) {
                        context.commit("SetCheckListList", data.data);
                    }
                    return;
                }
                if (Filter.pageId == 1) {
                    context.commit("SetCheckListNoMoreData", false);
                    context.commit("SetCheckListList", data.data);
                }
                else {
                    context.commit("SetCheckListNoMoreData", false);
                    context.commit("AddCheckListList", data.data);
                }
            });
    },
    GetCheckListModalListFromServer(context:any, Filter:any) {
        if (Filter == null) {
            Filter = { searchKey: "" };
        }
        if (state.Loading == true) {
            return;
        }
        context.commit("SetLoading", true);
        axios.get("CheckList/GetCheckListList", {
            params: {
                page: Filter.pageId,
                filterId: Filter.filterId,
                searchKey: Filter.searchKey,
                date: Filter.date
            }
        })
            .then((data:  any) => {
                context.commit("SetLoading", false);
                //context.commit('SetUpdateCheckListModalList', false);

                if (data.data.length < 1) {
                    context.commit("SetCheckListModalNoMoreData", true);
                    if (Filter.pageId == 1) {
                        context.commit("SetCheckListModalList", data.data);
                    }
                    return;
                }
                if (Filter.pageId == 1) {
                    context.commit("SetCheckListModalNoMoreData", false);
                    context.commit("SetCheckListModalList", data.data);
                }
                else {
                    context.commit("SetCheckListModalNoMoreData", false);
                    context.commit("AddCheckListModalList", data.data);
                }
            });
    },

    ClearCheckListList(context: { commit: (arg0: string, arg1: never[]) => void; }) {
        context.commit("SetCheckListList", []);
    },

    CreateCheckList(context:any, item:any) {
        context.commit("SetLoading", true);

        axios.post('CheckList/CheckListCreate', item).then((response:any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a: { errorMessage: any; }) => a.errorMessage);
                func.showErrorMessage(res.join('\n'));
            }
            else {
                func.showSuccessMessage("با موفقیت ثبت شد");
            }
            context.commit("SetLoading", false);
        }, (error: any) => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
    EditCheckList(context:any, item: any) {
        context.commit("SetLoading", true);

        axios.post('CheckList/CheckListCreate', item).then((response:any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a: { errorMessage: any; }) => a.errorMessage);
                alert(res.join('\n'));
            }
            else {
                router.go(-1);
            }
            context.commit("SetLoading", false);
        }, (error: any) => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
    CopyCheckList(context:any, Filter:any) {
        context.commit("SetLoading", true);

        axios.get('CheckList/CopyCheckList?id=', {
            params: {
                id: Filter.id
            }
        }).then(function (response:any) {
                console.log(response);
                if (response.status == 400 || response.data.success == false) {
                    const res = response.data.errors.map((a: { errorMessage: any; }) => a.errorMessage);
                    func.showErrorMessage(res.join('\n'));
                }
                else {
                    router.push({ name: 'CreateCheckList', params: { checkListId: response } });
                }
                context.commit("SetLoading", false);
            }, (error: any) => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },

};

export default {
    state,
    getters,
    mutations,
    actions
};
